/// <reference path="../include.ts" />

module gpx_visualizer_phase2 {

	export class ControllerLocationEvent extends alm.event.Event {

		public static CURRENT:string = "ControllerLocationEvent.CURRENT";





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(eventType:string, target:object) {
			super(eventType, target);
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------
	}
}
